import { capitalize } from '../../../assets/helpers/funciones';

export const inferVehicleClassVariant = (className) => {
  if (!className || typeof className !== 'string') return 'default';
  const n = className.toLowerCase();
  if (n.includes('moto')) return 'moto';
  if (
    n.includes('camión') ||
    n.includes('camion') ||
    n.includes('pickup') ||
    n.includes('camioneta') ||
    n.includes('cami')
  ) {
    return 'truck';
  }
  if (n.includes('automóvil') || n.includes('automovil') || n.includes('auto')) {
    return 'auto';
  }
  return 'default';
};

export const mapVehicleTypeFromApi = (row) => {
  const labels = (row.classes ?? [])
    .map((c) => String(c?.class ?? '').trim())
    .filter(Boolean);

  const vehicleClassName = labels.length
    ? labels.map((s) => capitalize(s.toLowerCase())).join(' / ')
    : '';

  const firstClassLabel = labels[0] ?? row.type ?? '';

  return {
    ...row,
    classId: row.classes?.[0]?._id ?? '',
    vehicleClassName,
    vehicleClassVariant: inferVehicleClassVariant(firstClassLabel),
  };
};
